import { useState } from 'preact/hooks'

import { useSearchspringContext } from '../fetchers/provider'
import { useBeaconLogImpressions, useBeaconLogRender } from '../hooks/useBeaconAnalytics'
import { useDataTracker } from '../hooks/useDataTracker'

import { ResultsCard } from './ResultCard'

export function GridResults({ title, className, sectionId, sectionName }) {
  const { results } = useSearchspringContext()
  const [node, setNode] = useState()

  // Analytics related hooks
  useBeaconLogRender()
  useBeaconLogImpressions(node)
  // Add data tracking for content click tracking
  const trackingRef = useDataTracker({
    sectionId: GM_STATE.cart.emptyCollectionId
  })

  if (results?.results?.length === 0) return null

  return (
    <div class="flex flex-col px-2">
      <p class="h4 py-4">{title}</p>
      <div
        class="grid grid-cols-2 gap-2"
        ref={(node) => {
          setNode(node)
          trackingRef(node)
        }}
        {...(sectionId && { 'data-dl-section-id': sectionId.toLowerCase() })}
        {...(sectionName && { 'data-dl-section-name': sectionName })}
      >
        {results?.results?.map((result, index) => (
          <div className={className}>
            <ResultsCard
              result={result}
              index={index}
              key={results.handle}
              className="wk-wishlist-button-target"
              wishlist={{ type: 'none' }}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
